export default __webpack_public_path__ + "static/media/TodascaDaniel.36976159.jpeg";